// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoTooltip--container--idFTd {
  width: 260px;
}

.InfoTooltip--row--ffMSw {
  line-height: 16px;
  color: var(--stat--default);
  margin-bottom: 8px;
  font-weight: medium;
}

.InfoTooltip--title--I97Ej {
  font-weight: bold;
}

.InfoTooltip--subtitle--S41E0 {
}

.InfoTooltip--note--wsFEw {
  font-style: italic;
}

.InfoTooltip--items--Eu1tq {
  padding-left: 24px;
  margin: 0 0 6px;
}

.InfoTooltip--item--qrd76 {
  margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/tooltips/InfoTooltip.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EAEE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EAEE,kBAAkB;AACpB","sourcesContent":[".container {\n  width: 260px;\n}\n\n.row {\n  composes: smallSize from '../../../styles/typography.css';\n  line-height: 16px;\n  color: var(--stat--default);\n  margin-bottom: 8px;\n  font-weight: medium;\n}\n\n.title {\n  composes: row;\n  font-weight: bold;\n}\n\n.subtitle {\n  composes: row;\n}\n\n.note {\n  composes: row;\n  font-style: italic;\n}\n\n.items {\n  padding-left: 24px;\n  margin: 0 0 6px;\n}\n\n.item {\n  composes: row;\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InfoTooltip--container--idFTd`,
	"row": `InfoTooltip--row--ffMSw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"title": `InfoTooltip--title--I97Ej InfoTooltip--row--ffMSw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"subtitle": `InfoTooltip--subtitle--S41E0 InfoTooltip--row--ffMSw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"note": `InfoTooltip--note--wsFEw InfoTooltip--row--ffMSw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"items": `InfoTooltip--items--Eu1tq`,
	"item": `InfoTooltip--item--qrd76 InfoTooltip--row--ffMSw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`
};
export default ___CSS_LOADER_EXPORT___;
